import equal from "fast-deep-equal";
import { useMemo } from "react";

import { useDataTableParamState } from "@/common/hooks/useDataTableParamState";
import { getDefaultColumnStates } from "@/common/utils/datatable";
import { CompaniesColumn, CompaniesSortBy } from "@reflag/shared/companyAPI";
import { SegmentDTO } from "@reflag/shared/segmentAPI";

export const defaultCompanyColumns: CompaniesColumn[] = [
  "name",
  "firstSeen",
  "lastSeen",
  "userCount",
];

export const useCompaniesTableState = (segment: SegmentDTO) => {
  // Load persisted sorting and column states from segment.
  const initialSorting = [
    {
      id: segment.columnSortKey ?? "name",
      desc: segment.columnSortDesc ?? false,
    },
  ];

  const initialColumnStates = useMemo(
    () =>
      segment.columns.length
        ? segment.columns
        : getDefaultColumnStates(defaultCompanyColumns),
    [segment.columns],
  );

  // Create table state from view data and url params.
  const tableState = useDataTableParamState<CompaniesSortBy, CompaniesColumn>({
    sorting: initialSorting,
    columnStates: initialColumnStates,
  });

  const isDirty =
    !equal(tableState.columnStates, initialColumnStates) ||
    !equal(tableState.sorting, initialSorting);

  return {
    ...tableState,
    isDirty,
    onReset: () => {
      tableState.onReset();
    },
  };
};
